// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".personal-data-forms[data-v-7dbe6a20]{max-width:800px}.personal-data-forms__intro[data-v-7dbe6a20]{color:#666;font-size:1rem;line-height:1.6;margin:1.5rem 0}.personal-data-forms__load-error[data-v-7dbe6a20]{margin:2rem 0}.personal-data-forms[data-v-7dbe6a20] .flash-message-box{margin-bottom:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
